import { Image } from 'antd';
import { useTranslation } from 'react-i18next';
import Logo from '../../../assets/company/logo.png';
import { useNavigate } from 'react-router-dom';

const SignInHeader = () => {
  const { t } = useTranslation('signIn');
  const navigate = useNavigate();

  return (
    <>
      <Image preview={false} src={Logo} width={250} onClick={() => navigate('/')} className='cursor-pointer' />
      <h1 className="mb-4 mt-4 w-full p-0 text-center text-2xl font-bold md:px-10">
        {/* {t('welcomeMessage')} */}
        {t('loginMessage')}
      </h1>
      {/* <p className="mb-4 text-base font-medium">{t('loginMessage')}</p> */}
    </>
  );
};

export default SignInHeader;
